/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useState } from 'react';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import AnimatedImage from '../../components/Animations/AnimatedImage';
import moment from 'moment-timezone';
import AnimatedButton from '../../components/Button';
import ApplicationContext from '../../context/ApplicationContext';
import { dataService } from '../../services/data.service';
import CarouselComponent from '../../components/Carousel';
import { generateDeviceFingerprint, groupIntoPairs, handleToast } from '../../helpers/CommonFunctions';
import ThreeDotsBlackLoader from '../../components/LoadingDots/ThreeDotsBlack';
import './styles.css';
import { appointmentLanguageContent } from './appointmentLanguageContent';

function AppointmentOptions(props) {
    const { facilityData, handlePage, currentAppointment, setCurrentAppointment, selectedLanguage, tempToken } = useContext(ApplicationContext);
    const [appointments, setAppointments] = useState('');
    const [pageLoading, setPageLoading] = useState(true);
    const [loading, setLoading] = useState('');

    useEffect(() => {
        dataService.getAppointmentDetails(tempToken).then((res) => {
            if(res.error === false) {
                setCurrentAppointment(res.data.data);
                dataService.getAllAppointmentDetails(tempToken, res.data.data.patient_id).then((res) => {
                    if(res.error === false) {
                        setAppointments(groupIntoPairs(res.data.data))
                        setPageLoading(false);
                    }
                })
            }
        })
    }, []);

    const handleStatusChange = (status) => {
        setLoading('confirm');
        const payload = {
            "patient_id": currentAppointment.patient_id,
            "fingerprint_id": generateDeviceFingerprint(),
            "appointment_status": status
        }
        dataService.changeAppointmentStatus(tempToken, payload).then((res) => {
            setLoading('')
            if(res.error === false) {
                handlePage('identity');
            } else {
                handleToast(res.data.data.message);
            }
        })
    }
    return (
        <AnimatedPageFade className={`flex flex-col ${pageLoading ? 'justify-start' : 'justify-between'} relative h-welcome gradient-bg rounded-[16px] overflow-auto`}>
            <p className='text-center font-semibold text-[#64A003] text-[24px] bg-[#F2F2F2] border-b border-[#D7D7D7] py-[10px] lg:text-[26px] xl:text-[32px] 2xl:text-[38px] flex justify-center items-center'>
                <AnimatedImage url="/images/Calendar.svg" alt="calendar" className="mr-[12px]" />
                <p className={selectedLanguage === 'ar' ? 'dir-rtl' : ''}>{appointmentLanguageContent['appointment'][selectedLanguage]}</p>
            </p>
            <div className='p-[8px] overflow-x-hidden overflow-y-auto options-height Form-scroll'>
                {!pageLoading && <p className={`font-semibold text-sm items-start text-[#333] ${selectedLanguage === 'ar' ? 'dir-rtl' : 'text-center'} break-words mt-[19px] lg:mb-[18px] xl:mb-[18px]`}>{appointmentLanguageContent['appt-3'][selectedLanguage]}</p>}
                {pageLoading ?
                    <div className='animate-pulse h-[127px] w-full bg-slate-300 rounded-lg' />
                    : <div data-testid="current_appointment" className='mt-[18px] border-2 border-[#007EB4] rounded-lg flex'>
                        <div className='bg-[#007EB4] flex flex-col items-center justify-center w-[20%] rounded-l-lg relative -left-[2px]'>
                            <p className='text-[#F2F2F2] text-[32px] font-semibold text-center fold-text'>{moment(currentAppointment.appointment_date).format('DD')}</p>
                            <p className='text-[#F2F2F2] text-[24px] font-semibold text-center fold-text'>{moment(currentAppointment.appointment_date).format('MMM')}</p>
                        </div>
                        <div className='w-[80%] mx-[10px] py-[10px]'>
                            <p className='text-[#007EB4] flex font-semibold text-base items-start fold-normal-text'>
                                <AnimatedImage url="/images/Doctor.svg" alt="doctor" className="mr-[12px]" />
                                {currentAppointment.doctor_name || '---'}
                            </p>
                            <p data-testid="facility_name" className='text-[#333] flex font-semibold text-sm items-start break-words mt-2 fold-normal-text'>
                                <AnimatedImage url="/images/Facility.svg" alt="facility" className="mr-[12px]" />
                                {facilityData.name || '---'}
                            </p>
                            <p className='text-[#333] flex font-semibold text-sm items-start break-words mt-2 fold-normal-text'>
                                <AnimatedImage url="/images/Time.svg" alt="time" className="mr-[12px]" />
                                {`${moment(currentAppointment.appointment_date).tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('hh:mm A z')}` || '---'}
                            </p>
                            <p className='text-[#333] flex font-semibold text-sm items-start break-words mt-2 fold-normal-text'>
                                <AnimatedImage url="/images/Phone.svg" alt="phone" className="mr-[12px]" />
                                {facilityData.contact_person_phone || '---'}
                            </p>
                        </div>
                    </div>}
                {appointments.length > 0 && <>
                    <p data-testid="para-2" className={`mt-[61px] font-normal text-[14px] ${selectedLanguage === 'ar' ? 'dir-rtl' : 'text-justify'} appt-text`}>
                        {appointmentLanguageContent['appt-4'][selectedLanguage]}</p>
                    <div className=''>
                        <CarouselComponent data={appointments} setCurrentAppointment={setCurrentAppointment} setAppointments={setAppointments} currentAppointment={currentAppointment} />
                    </div>
                </>}
            </div>
            {!pageLoading && <div className='flex mb-[24px] justify-between mx-[16px] w-auto fold-gap pt-[15px]'>
                {currentAppointment.enable_confirmation === true && 
                <AnimatedButton handleClick={() => handleStatusChange('Confirmed')} disabled={loading === 'confirm'} 
                    id="confirm_btn" className={`font-semibold text-gray bg-[#F2F2F2] w-[100px] h-[100px] text-sm justify-center fold-normal-text flex-col`} style={{borderRadius: '12px'}}>
                    {loading !== 'confirm' && <img src="/images/calendar-green.svg" alt="confirm" className='ml-[1.2em] w-[52px] h-[52px] mb-2 mr-[16px] fold-m-10' />}
                    {loading === 'confirm' ? <ThreeDotsBlackLoader /> : appointmentLanguageContent['confirm'][selectedLanguage]}
                </AnimatedButton>}
                <AnimatedButton disabled={loading === 'reschedule'} 
                    handleClick={() => handlePage('reschedule')}  id="reschedule_appointment" className={`font-semibold text-gray bg-[#F2F2F2] w-[100px] h-[100px] text-sm justify-center fold-normal-text flex-col`} style={{borderRadius: '12px'}}>
                    <img src="/images/Calendar-blue.svg" alt="reschedule" className='ml-[1.2em] w-[52px] h-[52px] mb-2 mr-[16px] fold-m-10' />
                    {appointmentLanguageContent['reschedule'][selectedLanguage]}
                </AnimatedButton>
                {facilityData.is_cancellation_reason_enabled && <AnimatedButton handleClick={() => handlePage('cancel')} 
                    disabled={loading === 'cancel'} id="cancel_appointment" className={`font-semibold text-gray bg-[#F2F2F2] w-[100px] h-[100px] text-sm justify-center fold-normal-text flex-col`} style={{borderRadius: '12px'}}>
                    <img src="/images/cancel.svg" alt="cancel" className='ml-[1.2em] w-[52px] h-[52px] mb-2 mr-[16px] fold-m-10' />
                    {appointmentLanguageContent['cancel'][selectedLanguage]}
                </AnimatedButton>}
            </div>}
        </AnimatedPageFade>
    );
}

export default AppointmentOptions;